The summary of what the price is for an advertisement product.

This is a human-readable string intended for displaying in a user interface.
